module.exports = __webpack_public_path__ + "assets/font/SourceHanSans-Normal-7f2c55dd.otf";